"use client"
import { AppBar, Toolbar, Typography, Button, makeStyles, Container } from "@material-ui/core"
import { VpnKey as KeyIcon } from "@material-ui/icons"
import { useHistory } from "react-router-dom"
import firebase from "../firebase"

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  icon: {
    marginRight: theme.spacing(1),
    fontSize: "2rem",
  },
}))

function Navbar() {
  const classes = useStyles()
  const history = useHistory()

  const handleLogout = async () => {
    try {
      await firebase.auth().signOut()
      history.push("/")
    } catch (error) {
      console.error("Error signing out: ", error)
    }
  }

  return (
    <AppBar position="static" className="navbar">
      <Container>
        <Toolbar>
          <Typography variant="h6" className={`${classes.title} navbar-title`}>
            <KeyIcon className={classes.icon} />
            Dynamic QR System
          </Typography>
          <Button className="logout-button" onClick={() => history.push("/dashboard")} style={{ marginRight: "0.5rem" }}>
            Dashboard
          </Button>
          <Button className="logout-button" onClick={() => history.push("/export")} style={{ marginRight: "0.5rem" }}>
            Export
          </Button>
          <Button className="logout-button" onClick={() => history.push("/scans")} style={{ marginRight: "0.5rem" }}>
            Scans
          </Button>
          <Button className="logout-button" onClick={handleLogout}>
            Logout
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default Navbar

